import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface DailySalesState {
  totalAmount: number
  loading: boolean
  error: string | null
}

const initialState: DailySalesState = {
  totalAmount: 0,
  loading: false,
  error: null,
}

const dailySalesSlice = createSlice({
  name: 'dailySales',
  initialState,
  reducers: {
    // Action para definir o total de vendas (substitui o valor atual)
    // Usado quando a API retorna o total acumulado da jornada
    setDailyTotal: (state, action: PayloadAction<number>) => {
      state.totalAmount = action.payload
    },
    
    // Action para resetar as vendas do dia
    resetDailyTotal: (state) => {
      state.totalAmount = 0
    },
    
    // Actions para controle de loading/error
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
  },
})

export const {
  setDailyTotal,
  resetDailyTotal,
  setLoading,
  setError,
} = dailySalesSlice.actions

export default dailySalesSlice.reducer